(function () {
  // print button
  let element = document.querySelector('[data-resource-action="download"]');
  if (element) {
    // eslint-disable-next-line no-unused-vars
    element.addEventListener("click", (event) => {
      window.print();
    });
  }
  var url = document.querySelector(".url-input");
  if (url) {
    url.value = window.location.href;
  }
})();
